export default __webpack_public_path__ + "c9d46057ad845daf30727d95b4f9c373.svg";